document.addEventListener('DOMContentLoaded', () => {

  const mainImage = document.getElementById('SMMainImage');

  if (!mainImage) return;

  /*
  ==========================
  LEFT THUMBNAILS
  ==========================
  */
  document.querySelectorAll('.sm-thumb').forEach((thumb) => {

    thumb.addEventListener('click', () => {

      const fullImage = thumb.dataset.full;

      if (!fullImage) return;

      mainImage.src = fullImage;

      // active class
      document.querySelectorAll('.sm-thumb').forEach((item) => {
        item.classList.remove('active');
      });

      thumb.classList.add('active');

    });

  });

  /*
  ==========================
  BOTTOM GALLERY
  ==========================
  */
  document.querySelectorAll('.sm-bottom-item').forEach((item) => {

    item.addEventListener('click', () => {

      const fullImage = item.dataset.full;

      if (!fullImage) return;

      mainImage.src = fullImage;

    });

  });

});

const variants = JSON.parse(
  document.getElementById('SMVariants').textContent
);
// ── ELEMENT REFS ──────────────────────────────

const variantInput    = document.getElementById('SMVariantId');
const priceEl         = document.getElementById('SMPrice');
const buttonPriceEl   = document.getElementById('SMButtonPrice');
const stockEl         = document.getElementById('SMStock');
const selectedSizeEl  = document.getElementById('SMSelectedSize');
const addToCartBtn    = document.getElementById('SMAddToCart');
const addToCartText   = document.getElementById('SMAddToCartText');
const afterpayEl      = document.getElementById('SMAfterpay');
const mainImage       = document.getElementById('SMMainImage');

// ========================
// MONEY FORMATTER

// ========================
function money(cents) {
  if (
    typeof Shopify !== 'undefined' &&
    typeof Shopify.formatMoney === 'function' &&
    window.theme &&
    window.theme.settings &&
    window.theme.settings.moneyFormat
  ) {
    return Shopify.formatMoney(
      cents,
      window.theme.settings.moneyFormat
    );
  }

  return new Intl.NumberFormat(undefined, {
    style: 'currency',
    currency: Shopify?.currency?.active || 'AUD'
  }).format(cents / 100);
}


function getSelectedOptions() {
  const size  = document.querySelector('input[name="option-size"]:checked')?.value  ?? null;
  const color = document.querySelector('input[name="option-color"]:checked')?.value ?? null;
  return { size, color };
}

// ========================
// FIND VARIANT

// ========================
function findVariant() {
  const { size, color } = getSelectedOptions();

  return variants.find((v) => {

    const options = [
      v.option1,
      v.option2,
      v.option3
    ];

    const hasSize = size ? options.includes(size) : true;
    const hasColor = color ? options.includes(color) : true;

    return hasSize && hasColor;
  }) || null;
}

// ========================
// UPDATE UI

// ========================
function updateVariant() {
  const variant = findVariant();

  if (!variant) {
    // No matching variant — disable button
    addToCartBtn.disabled = true;
    addToCartBtn.classList.add('disabled');
    addToCartText.innerHTML = 'SELECT OPTIONS';
    return;
  }

  // ── Variant ID (used by Shopify add-to-cart form) ──
  variantInput.value = variant.id;

  // ── Price ──
 
  const formattedPrice = money(variant.price);
  priceEl.innerHTML       = formattedPrice;
  buttonPriceEl.innerHTML = formattedPrice;

 
  afterpayEl.innerHTML = money(Math.round(variant.price / 4));

  // ── Selected size label ──
  if (selectedSizeEl) {
    selectedSizeEl.innerHTML = variant.option1 || '';
  }

 
  const qty = variant.inventory_quantity ?? 0;

  if (variant.available && qty > 0) {
    const isLow = qty <= 10;

    stockEl.innerHTML = `
      <span class="sm-stock-dot"></span>
      <span class="sm-stock-text">In stock</span>
      <span class="sm-stock-divider">·</span>
      <span class="sm-stock-low">
        ${isLow ? `Only ${qty} left` : `${qty} available`}
      </span>
    `;

    addToCartBtn.disabled = false;
    addToCartBtn.classList.remove('disabled');
    addToCartText.innerHTML = 'ADD TO CART';

  } else {
    stockEl.innerHTML = `
      <span class="sm-stock-dot out"></span>
      <span class="sm-stock-out">Out of stock</span>
    `;

    addToCartBtn.disabled = true;
    addToCartBtn.classList.add('disabled');
    addToCartText.innerHTML = 'OUT OF STOCK';
  }

  // ── Main image swap ──
 if (
  variant.featured_media &&
  variant.featured_media.id
) {

  const mediaId = variant.featured_media.id;

  // Desktop image
  if (mainImage && variant.featured_media.preview_image) {

    const src = variant.featured_media.preview_image.src;

    mainImage.src = src.includes('?')
      ? src + '&width=1600'
      : src + '?width=1600';
  }

  // Mobile slider
  const targetSlide = document.querySelector(
    `.sm-slide[data-media-id="${mediaId}"]`
  );

  const slider = document.getElementById('SMMobileSlider');

  if (targetSlide && slider) {
    slider.scrollTo({
      left: targetSlide.offsetLeft,
      behavior: 'smooth'
    });
  }
}
}

function renderSales7d() {
  const el = document.getElementById('SMSales7dEl');
  if (!el) return;

  // Try reading from injected JSON tag first
  const jsonTag = document.getElementById('SMSales7d');
  let sales = 0;

  if (jsonTag) {
    try {
      sales = parseInt(JSON.parse(jsonTag.textContent), 10) || 0;
    } catch (e) {
      sales = 0;
    }
  } else if (window.SM && window.SM.sales7d) {
    sales = window.SM.sales7d || 0;
  }

  if (sales > 0) {
    el.innerHTML = `${sales} sold in the last week`;
    el.style.display = '';
  } else {
    el.style.display = 'none';
  }
}

// ========================
// EVENTS — option changes
// ========================
document
  .querySelectorAll('input[name="option-size"], input[name="option-color"]')
  .forEach((input) => {
    input.addEventListener('change', updateVariant);
  });

// ========================
// QUANTITY CONTROLS
// ========================
document.querySelectorAll('.plus').forEach((btn) => {
  btn.addEventListener('click', function () {
    const input = this.parentElement.querySelector('.sm-qty-input');
    if (input) input.value = parseInt(input.value, 10) + 1;
  });
});

document.querySelectorAll('.minus').forEach((btn) => {
  btn.addEventListener('click', function () {
    const input = this.parentElement.querySelector('.sm-qty-input');
    if (input && parseInt(input.value, 10) > 1) {
      input.value = parseInt(input.value, 10) - 1;
    }
  });
});

updateVariant();
renderSales7d();


document.addEventListener('click', function(e){

  const trigger = e.target.closest('.jdgm-prev-badge');

  if(!trigger) return;

  const reviewsSection = document.querySelector('.rv-section');

  if(reviewsSection){
    reviewsSection.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  }

});


/* ================================
   MOBILE SLIDER — dot indicators + thumb sync
================================ */
(function () {

  const slider = document.getElementById('SMMobileSlider');
  if (!slider) return;

  const dots  = document.querySelectorAll('#SMDots .sm-dot');
  const slides = slider.querySelectorAll('.sm-slide');
  const thumbs = document.querySelectorAll('.sm-thumb');

  if (!dots.length || !slides.length) return;

  let currentIndex = 0;

  function setActive(index) {
    if (index === currentIndex && index !== 0) return;
    currentIndex = index;

    // Update dots
    dots.forEach((d, i) => d.classList.toggle('active', i === index));

    // Sync desktop thumbs
    thumbs.forEach((t, i) => t.classList.toggle('active', i === index));
  }

  // IntersectionObserver — fires when a slide is ≥50% visible
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const index = parseInt(entry.target.dataset.index, 10);
          setActive(index);
        }
      });
    },
    {
      root: slider,
      threshold: 0.5,
    }
  );

  slides.forEach((slide) => observer.observe(slide));

  // When a desktop thumb is clicked, also scroll mobile slider to that index
  thumbs.forEach((thumb, i) => {
    thumb.addEventListener('click', () => {
      const target = slides[i];
      if (target && window.innerWidth <= 768) {
        slider.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
      }
    });
  });

})();

document.addEventListener('DOMContentLoaded', () => {

  const modal = document.getElementById('SMVideoModal');
  const popupVideo = document.getElementById('SMPopupVideo');
  const closeBtn = document.getElementById('SMVideoClose');

  document.querySelectorAll('.sm-video-card').forEach(card => {

    card.addEventListener('click', () => {

      const sourceVideo = card.querySelector('video');

      if (!sourceVideo) return;

      const source = sourceVideo.querySelector('source');

      if (source) {
        popupVideo.src = source.src;
      } else {
        popupVideo.src = sourceVideo.currentSrc;
      }

      modal.classList.add('active');

      popupVideo.play();

    });

  });

  closeBtn.addEventListener('click', () => {

    modal.classList.remove('active');

    popupVideo.pause();
    popupVideo.currentTime = 0;

  });

  modal.addEventListener('click', (e) => {

    if (e.target === modal) {

      modal.classList.remove('active');

      popupVideo.pause();
      popupVideo.currentTime = 0;

    }

  });

  document.querySelectorAll('.bundle-add-btn').forEach(button => {

  button.addEventListener('click', function (e) {

    e.preventDefault();
    e.stopPropagation();

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        items: [{
          id: this.dataset.variantId,
          quantity: 1
        }]
      })
    })
    .then(res => res.json())
    .then(() => {
      window.location.href = '/cart';
    });

  });

});
  



  function updateBundleHeading() {

    const selectedSize =
      document.querySelector('input[name="option-size"]:checked')?.value || '';

    document.querySelectorAll('.heading-160').forEach(el => {
      el.style.display = selectedSize.includes('185') ? 'none' : '';
    });

    document.querySelectorAll('.heading-185').forEach(el => {
      el.style.display = selectedSize.includes('185') ? '' : 'none';
    });
  }

  document.addEventListener('change', function(e){
    if(e.target.matches('input[name="option-size"]')){
      updateBundleHeading();
    }
  });

  updateBundleHeading();




});
